import { APIResponse, returnAxios } from 'app/shared/util/class-utils';
import axios, { AxiosResponse } from 'axios';
import { ICustomer } from '../model/customer.model';

export interface ICustomerApi {
  saveCustomer(customer: ICustomer): Promise<APIResponse<any>>;
}

export class CustomerApi implements ICustomerApi {
  async saveCustomer(customer: ICustomer): Promise<APIResponse<any>> {
    return returnAxios(axios.put('/journey/subscribers', customer));
  }
}
